import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mtw_lang") || "ar");

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    localStorage.setItem("mtw_lang", lang);
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) { node = node?.[p]; if (node === undefined) break; }
    return node ?? path;
  }, [lang]);

  const isAr = lang === "ar";
  const dir = isAr ? "rtl" : "ltr";

  const localize = useCallback((obj, field) => {
    if (!obj) return "";
    return obj[`${field}_${lang}`] ?? obj[`${field}_ar`] ?? obj[`${field}_en`] ?? "";
  }, [lang]);

  const fmtSAR = useCallback((n) => {
    const v = Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return isAr ? `${v} ر.س` : `SAR ${v}`;
  }, [isAr]);

  const fmtDate = useCallback((iso, withTime = true) => {
    if (!iso) return "";
    const d = new Date(iso);
    const opts = { year: "numeric", month: "short", day: "numeric", timeZone: "Asia/Riyadh", numberingSystem: "latn" };
    const greg = new Intl.DateTimeFormat(isAr ? "ar-u-ca-gregory" : "en-GB", opts).format(d);
    const hijri = new Intl.DateTimeFormat("ar-SA-u-ca-islamic-umalqura", opts).format(d);
    const time = withTime ? new Intl.DateTimeFormat(isAr ? "ar" : "en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Riyadh", numberingSystem: "latn" }).format(d) : "";
    return { greg, hijri, time };
  }, [isAr]);

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t, isAr, dir, localize, fmtSAR, fmtDate }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
